module.exports = __webpack_public_path__ + "static/media/Icon_Delegates.f3baf910.svg";